<template>
    <div class="text-response">
        <span v-if="response != null && response[0]" class="choice answer">
                {{ response[0].answer }} {{ response[0].display_text }}
        </span>
        <div v-else :class="['no-answer', {'is-multi' : isMulti}]">
            <span>
                Not Answered
            </span>
        </div>
    </div>
</template>

<script>

export default {   
    name: 'unit-partial',

    props: {
		response: {
			type: Array,
            default: () => [],
		},
        isMulti: {
            type: Boolean
        }
	},
}
</script>

<style lang="scss" scoped>
@import "../style.scss";
.no-answer.is-multi > span{
    display: block;
    padding: 8px 18px;
    border: 1px solid #eeeeee;
}
</style>
